module.exports = __webpack_public_path__ + "img/remision_2.fde82398.png";